<div class="inside-loading"><div class="icons"><i class="bi bi-gear a"></i><i class="bi bi-gear b"></i></div></div>